import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AssetFilterBar = ({ onFilterChange, totalCount, filteredCount }) => {
  const [filters, setFilters] = useState({
    type: '',
    orientation: '',
    campaign: '',
    search: ''
  });

  const [showAdvanced, setShowAdvanced] = useState(false);

  const typeOptions = [
    { value: '', label: 'All Asset Types' },
    { value: 'logo', label: 'Logos' },
    { value: 'technology', label: 'Technology Visuals' },
    { value: 'photo', label: 'Practice Photos' },
    { value: 'diagram', label: 'Medical Diagrams' },
    { value: 'video', label: 'Video Clips' }
  ];

  const orientationOptions = [
    { value: '', label: 'All Orientations' },
    { value: 'landscape', label: 'Landscape' },
    { value: 'portrait', label: 'Portrait' },
    { value: 'square', label: 'Square' }
  ];

  const campaignOptions = [
    { value: '', label: 'All Campaigns' },
    { value: 'Q1 2026 Launch', label: 'Q1 2026 Launch' },
    { value: 'Brand Awareness', label: 'Brand Awareness' },
    { value: 'Patient Education', label: 'Patient Education' },
    { value: 'Technology Innovation', label: 'Technology Innovation' }
  ];

  const handleFilterChange = (key, value) => {
    const updatedFilters = { ...filters, [key]: value };
    setFilters(updatedFilters);
    if (onFilterChange) {
      onFilterChange(updatedFilters);
    }
  };

  const handleSearchChange = (e) => {
    handleFilterChange('search', e?.target?.value);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      type: '',
      orientation: '',
      campaign: '',
      search: ''
    };
    setFilters(clearedFilters);
    if (onFilterChange) {
      onFilterChange(clearedFilters);
    }
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-sm">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search assets by name, campaign, or type..."
            value={filters?.search}
            onChange={handleSearchChange}
            className="w-full"
          />
        </div>

        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            onClick={() => setShowAdvanced(!showAdvanced)}
            iconName={showAdvanced ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="right"
          >
            Advanced Filters
          </Button>

          {hasActiveFilters && (
            <Button
              variant="ghost"
              onClick={handleClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear All
            </Button>
          )}
        </div>
      </div>
      {showAdvanced && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-border">
          <Select
            label="Asset Type"
            options={typeOptions}
            value={filters?.type}
            onChange={(value) => handleFilterChange('type', value)}
          />

          <Select
            label="Orientation"
            options={orientationOptions}
            value={filters?.orientation}
            onChange={(value) => handleFilterChange('orientation', value)}
          />

          <Select
            label="Campaign"
            options={campaignOptions}
            value={filters?.campaign}
            onChange={(value) => handleFilterChange('campaign', value)}
          />
        </div>
      )}
      <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
        <p className="text-sm text-muted-foreground font-caption">
          <Icon name="Image" size={14} className="inline mr-2" />
          {hasActiveFilters ? (
            <>Showing {filteredCount} of {totalCount} assets</>
          ) : (
            <>{totalCount} total assets available</>
          )}
        </p>

        {hasActiveFilters && (
          <div className="flex items-center gap-2 text-sm text-primary">
            <Icon name="Filter" size={14} />
            <span className="font-medium">Filters Active</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetFilterBar;